module.exports = __webpack_public_path__ + "static/media/rectangle-copy.deeb94e3.png";